import "core-js/modules/es.array.fill.js";
import Colors from "../../Color/Colors";
import { Icon } from "../../Icon/Icon/Icon";
import styles from "./SpinnerIndicator.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var SpinnerIndicator = function SpinnerIndicator(_ref) {
  var _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 1000 : _ref$duration,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? Colors.colorBlack : _ref$fill,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '20px' : _ref$size;
  return /*#__PURE__*/_jsx("div", {
    className: styles.spinner,
    style: {
      animationDuration: "".concat(duration / 1000, "s"),
      animationTimingFunction: 'linear',
      animationIterationCount: 'infinite',
      height: size,
      width: size
    },
    children: /*#__PURE__*/_jsx(Icon, {
      type: "status-loading",
      fill: fill,
      height: size,
      width: size,
      className: styles.spinnerIcon
    })
  });
};